module.exports = __webpack_public_path__ + "img/carport.0a8d6e12.webp";